import { c as create_ssr_component, d as add_attribute } from "./ssr.js";
const RemoveButton = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { value } = $$props;
  let { onClick = () => {
  } } = $$props;
  let { classes = "text-center" } = $$props;
  if ($$props.value === void 0 && $$bindings.value && value !== void 0) $$bindings.value(value);
  if ($$props.onClick === void 0 && $$bindings.onClick && onClick !== void 0) $$bindings.onClick(onClick);
  if ($$props.classes === void 0 && $$bindings.classes && classes !== void 0) $$bindings.classes(classes);
  return `<div${add_attribute("class", classes, 0)}><button type="button" class="rounded-full border p-1 text-red-600 shadow-sm hover:bg-red-500 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600" data-svelte-h="svelte-1eygubx"><svg class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6"></path></svg></button></div>`;
});
export {
  RemoveButton as R
};
//# sourceMappingURL=RemoveButton.js.map
